const t = typeof window < "u" && typeof document < "u", o = typeof navigator == "object" && navigator || void 0, a = t && (!o || ["ReactNative", "NativeScript", "NS"].indexOf(o.product) < 0), e = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", r = t && window.location.href || "http://localhost";
export {
  t as hasBrowserEnv,
  a as hasStandardBrowserEnv,
  e as hasStandardBrowserWebWorkerEnv,
  o as navigator,
  r as origin
};
//# sourceMappingURL=index.es353.js.map
